module.exports = __webpack_public_path__ + "img/logo.78771895.png";